import { useEffect, useState } from 'react';

import sendAxios from '@lcsc-ui/utils/request';
import { message } from 'antd';

import API from '@/apis/index';
import CouponDialog from '@/components/detailPage/components/couponDialog';
import { lcBookProvider } from '@/constants';

export default function OvseaProductDiscountActivity({ data }) {
  const [showCouponDialog, setShowCouponDialog] = useState(false);
  const [couponInfo, setCouponInfo] = useState({});
  const [loginStatus, setLoginStatus] = useState('');
  const [isShowCouponByOversea, setIsShowCouponByOversea] = useState(false);
  const [isShowCouponByBook, setIsShowCouponByBook] = useState(false);
  const [couponData, setCouponData] = useState({});
  const productRecord = data?.productRecord;
  const providerIsLCDH = lcBookProvider.includes(data?.provider);

  useEffect(() => {
    if (providerIsLCDH) {
      renderLcBookCoupon();
    } else {
      renderOverseaCoupon();
    }
  }, []);

  const renderOverseaCoupon = () => {
    sendAxios({
      method: 'GET',
      baseURL: 'lcscActivityUrl',
      url: API.isCouponUnavailableForOversea,
    }).then((res) => {
      if (res?.result === false) {
        getOverseaProductsCouponInfo();
      }
    });
  };

  const getOverseaProductsCouponInfo = () => {
    sendAxios({
      method: 'post',
      baseURL: 'lcscActivityUrl',
      url: API.activityOverseaCouponTips,
      data: [{ provider: productRecord?.provider, brandId: productRecord?.brandId }],
    }).then((res) => {
      if (res.code === 200 && res.result) {
        const key = productRecord?.provider + '_' + productRecord?.brandId;
        setCouponInfo({ ...res.result[key] });
        setIsShowCouponByOversea(true);
      }
    });
  };

  const renderLcBookCoupon = () => {
    sendAxios({
      method: 'post',
      baseURL: 'lcscActivityUrl',
      url: API.couponLabelShow,
      data: [{ productCode: productRecord?.productCode, brandId: productRecord?.brandId }],
    }).then((res) => {
      if (res.code === 200 && res.result && res.result[productRecord?.productCode]) {
        const data = res.result[productRecord?.productCode];
        setCouponInfo({
          ...data?.couponInfo,
          hasPlusCoupon: data?.hasPlusCoupon,
          productId: data?.productId,
          isCouponUnavailable: data?.isCouponUnavailable,
        });
        if (data?.couponInfo || data?.hasPlusCoupon) {
          setIsShowCouponByBook(true);
        }
      }
    });
  };

  const closeCoupon = () => {
    setShowCouponDialog(false);
    setCouponData({});
  };

  const clickSetCoupon = () => {
    setShowCouponDialog(true);
    let couponUrl = '';
    if (providerIsLCDH) {
      couponUrl = `${API.activityCoupon}?isLcBook=true&productId=${couponInfo.productId}&brandId=${productRecord?.brandId}`;
    } else {
      couponUrl = `${API.activityCoupon}?isOversea=1&provider=${productRecord?.provider}&brandId=${productRecord?.brandId}`;
    }
    sendAxios({
      method: 'GET',
      baseURL: 'lcscActivityUrl',
      url: couponUrl,
    })
      .then(({ result }) => {
        setLoginStatus(result?.loginStatus);
        setCouponData(result);
      })
      .catch((error) => {
        if (error?.msg) {
          message.error(`${error?.msg}`);
        }
      });
  };

  // 不可用优惠
  const ProductCouponUnavailable = () => {
    return (
      <ul className="text-[14px] text-[#56657F] flex flex-wrap">
        <li className="mt-[6px] mr-[8px] h-[20px] rounded-[4px] border-[1px] border-solid border-[#FFBEC6] bg-[#FFEDEF] p-[0_2px] text-center text-[12px] text-[#FF4960]">
          不可用商品券
        </li>
      </ul>
    );
  };

  const OverseaPage = () => {
    return (
      <div className="flex">
        {couponInfo?.hasPlusCoupon && (
          <button
            onClick={clickSetCoupon}
            className="mt-[6px] mr-[8px] flex items-center bg-gradient-to-r h-[20px] from-[#F9DB7C] to-[#E9A944] text-[#fff] text-[12px] rounded bold"
          >
            <p className="pl-[5px] pr-[5px]">PLUS专享</p>
          </button>
        )}
        {couponInfo?.isFreeExpress ? (
          <button
            onClick={clickSetCoupon}
            className="mt-[6px] mr-[8px] flex items-center text-[#0093E6] h-[18px] text-[12px] border-[#0093E6] border-[1px] border-solid rounded-[4px] cursor-pointer hover:opacity-[0.8]"
          >
            <p className="bg-[#0093E6] text-[white] pl-[3px] pr-[4px] rounded-tl-[4px] rounded-bl-[4px] rounded-br-[8px]">
              运
            </p>
            <p className="pl-[5px] pr-[5px]">包邮券</p>
          </button>
        ) : couponInfo?.couponType === 'discount' ? (
          <button
            onClick={clickSetCoupon}
            className="mt-[6px] mr-[8px] flex items-center text-[#FF4960] h-[18px] text-[12px] border-[#FF4960] border-[1px] border-solid rounded-[4px] cursor-pointer hover:opacity-[0.8]"
          >
            <p className="bg-[#FF4960] text-[white] pl-[3px] pr-[4px] rounded-tl-[4px] rounded-bl-[4px] rounded-br-[8px]">
              折
            </p>
            <p className="pl-[5px] pr-[5px]">{couponInfo?.couponDiscount / 10}折</p>
          </button>
        ) : couponInfo?.couponType === 'product' ? (
          <button
            onClick={clickSetCoupon}
            className="mt-[6px] mr-[8px] flex items-center text-[#FF4960] h-[18px] text-[12px] border-[#FF4960] border-[1px] border-solid rounded-[4px] cursor-pointer hover:opacity-[0.8]"
          >
            <p className="bg-[#FF4960] text-[white] pl-[3px] pr-[4px] rounded-tl-[4px] rounded-bl-[4px] rounded-br-[8px]">
              商
            </p>
            <p className="pl-[5px] pr-[5px]">
              满{couponInfo?.couponThresholdMoney}减{couponInfo?.couponAmount}
            </p>
          </button>
        ) : (
          couponInfo?.couponType === 'freight' && (
            <button
              onClick={clickSetCoupon}
              className="mt-[6px] mr-[8px] flex items-center text-[#0093E6] h-[18px] text-[12px] border-[#0093E6] border-[1px] border-solid rounded-[4px] cursor-pointer hover:opacity-[0.8]"
            >
              <p className="bg-[#0093E6] text-[white] pl-[3px] pr-[4px] rounded-tl-[4px] rounded-bl-[4px] rounded-br-[8px]">
                运
              </p>
              <p className="pl-[5px] pr-[5px]">{couponInfo?.couponAmount}元</p>
            </button>
          )
        )}
      </div>
    );
  };
  return (
    <>
      {(isShowCouponByOversea || isShowCouponByBook) && (
        <div className="text-[14px] text-[#56657F] items-center mt-[16px]">
          <h3 className="mr-[28px] text-[14px] text-[#020202] font-bold">优惠活动</h3>
          {couponInfo?.isCouponUnavailable ? <ProductCouponUnavailable /> : <OverseaPage />}
          {showCouponDialog && (
            <CouponDialog
              isOpen={showCouponDialog}
              couponData={couponData}
              loginStatus={loginStatus}
              clickSetCoupon={clickSetCoupon}
              onClose={closeCoupon}
              isMro={data?.isMro}
            />
          )}
        </div>
      )}
    </>
  );
}
